import {Box, Typography} from "@mui/material";
import {c} from "../landingTokens";
import {Eyebrow, Section} from "./Shell";

const FAQS = [
  {
    q: "Do we have to replace our phone system?",
    a: "No. Your Avaya or existing phone central trunks into our Asterisk over standard SIP. Your numbers, routing and agent desktops stay exactly as they are — the AI simply becomes one more destination calls can reach.",
  },
  {
    q: "How does the AI actually hear the call?",
    a: "Through our custom SIP connector, which streams the live audio to and from the agent over AudioSocket. That direct audio path is what keeps the response under a second, with no menus or beeps in between.",
  },
  {
    q: "Can we change how the agent behaves?",
    a: "Yes — the conversation logic is a flow you design in the OpenBrain app. Prompts, branches, guardrails and escalation rules are edited there and take effect without a software release.",
  },
  {
    q: "How does it reach our own systems?",
    a: "The flow calls your APIs through MCP tools and REST endpoints, so it can check a balance, reschedule an appointment or open a ticket while the caller is still on the line.",
  },
  {
    q: "Can a supervisor take over a live call?",
    a: "Yes. The supervision interface lists every conversation in progress, and a supervisor can stop the AI mid-call and redirect the caller to an Avaya phone, or place an outbound call to their own Avaya extension directly from the interface.",
  },
  {
    q: "Is every conversation logged and reviewable?",
    a: "Every call is logged with its full transcript and the path it took through the flow. Supervisors leave comments on specific turns, and those notes become the change list for the next iteration of the flow — the agent gets better from real traffic, not guesswork.",
  },
  {
    q: "Which languages are supported?",
    a: "English, Macedonian, Serbian and Croatian are live today, and we can train models for any additional language you need. A single agent can switch language mid-call based on the caller.",
  },
  {
    q: "Where is call data stored?",
    a: "EU cloud by default, with on-premise deployment available. Recordings and transcripts support redaction of sensitive fields and full audit logging under GDPR.",
  },
  {
    q: "How long does a rollout take?",
    a: "Typically three to six weeks: one week of discovery and intent mapping, a shadow-mode pilot on real traffic, then a gradual switch of call volume to the agent.",
  },
];

export const Faq = () => (
  <Section id="faq" label="FAQ">
    <Box sx={{maxWidth: 980, mx: "auto"}}>
      <Eyebrow>FAQ</Eyebrow>
      <Typography component="h2" sx={{fontSize: "clamp(30px, 4.2vw, 50px)", lineHeight: 1.05, letterSpacing: "-0.03em", fontWeight: 600, mb: 5}}>
        Questions, answered.
      </Typography>

      <Box sx={{border: `1px solid ${c.line}`, borderRadius: "28px", overflow: "hidden", bgcolor: c.bgSoft, boxShadow: "0 22px 60px -48px rgba(55, 56, 113, 0.55)"}}>
        {FAQS.map((item) => (
          <Box
            key={item.q}
            sx={{
              borderTop: `1px solid ${c.lineStrong}`,
              py: 3.25,
              px: {xs: 2.5, md: 4},
              display: "grid",
              gridTemplateColumns: {xs: "1fr", md: "1fr 1.35fr"},
              gap: {xs: 1.5, md: 3.5},
              transition: "background-color 180ms ease",
              "&:first-of-type": {borderTop: "none"},
              "&:hover": {bgcolor: "rgba(238,240,255,0.72)"},
            }}
          >
            <Typography component="h3" sx={{fontSize: 17, fontWeight: 600, letterSpacing: "-0.01em"}}>{item.q}</Typography>
            <Typography sx={{fontSize: 15, lineHeight: 1.6, color: c.inkSoft}}>{item.a}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  </Section>
);
